import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AuthPageLayout } from '../shared/components/containers/AuthPageLayout';
import { BrandHeader } from '../shared/components/headers/BrandHeader';
import { BasicAnchor } from '../shared/components/links/BasicAnchor';

// Sentry.ErrorBoundary's fallback — shown if a React render crashes
// somewhere in the tree. Sentry has already captured the error by the time
// this renders; this is just what the user sees instead of a blank page.
const Heading = styled.div`
  font-weight: 600;
  font-size: 1.3em;
  margin-bottom: 5px;
`;

const Explanation = styled.div`
  color: ${(props) => props.theme.colors.mutedText};
  margin-bottom: 20px;
`;

const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <AuthPageLayout>
      <BrandHeader/>
      <Heading>{t('errorFallback.heading')}</Heading>
      <Explanation>{t('errorFallback.explanation')}</Explanation>
      <BasicAnchor url="/">{t('errorFallback.backHome')}</BasicAnchor>
    </AuthPageLayout>
  );
};

export {
  ErrorFallback,
};
